import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import { greeting } from "../../portfolio.js";
import { t } from "i18next";
import { Link } from "react-router-dom";

/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer(props) {
  const theme = props.theme;
  return (
    <div className="footer-div">
      <Fade>
        <p className="footer-text" style={{ color: props.theme.secondaryText }}>
          © Copyright {new Date().getFullYear()} | {t("titles.made-with")}{" "}
          <span role="img">❤️</span> {t("by")} {greeting.title2} |{" "}
          <Link style={{ color: theme.secondaryText }} to={"privacy-notice"}>
            {t("titles.privacy-notice")}
          </Link>
        </p>
      </Fade>
    </div>
  );
}
